export const RECOMMENDATION_TRACKING_KEYS = {
  REC_MODULE_ID: 'rec_module_id',
  REC_ELEMENT_NAME: 'rec_element_name',
  REC_PRODUCT_COUNT: 'rec_product_count',
  IS_CART_MODAL: 'is_cart_modal',
} as const

export type RecommendationTrackingKey = keyof typeof RECOMMENDATION_TRACKING_KEYS
